export default "__VITE_ASSET__srUxEJ5N__"